import ApplicationController from "./application_controller";

export default class extends ApplicationController {
  connect() {
    super.connect();
    console.log("Helper js en cours ..");
  }
}
